import React, { useState } from 'react';
import { createUserWithEmailAndPassword, signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../utils/firebase';
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { ToastContainer, toast } from 'react-toastify'
import Terms from './Terms';
import { checkEmpty, getAuthErrorMessage, spinner, makeid, getDate90DaysOut } from "../utils/Helper"

// import firebase
import { getFirestore, collection, getDocs, setDoc, doc, query, where } from 'firebase/firestore'

const SignUp = ({ onSendToParent }) => {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('');
    const [name, setName] = useState('');
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const [completeFields, setCompleteFields] = useState('')

    const onSubmit = async (e) => {
        if (!checkEmpty(name) && !checkEmpty(email) && !checkEmpty(password)) {
            e.preventDefault()
            await createUserWithEmailAndPassword(auth, email, password)
                .then((userCredential) => {
                    toast.success("Account created successfully! Please log in.")
                    if (!checkEmpty(userCredential.user.email)) {
                        Login()
                    }
                })
                .catch((error) => {
                    toast.error(getAuthErrorMessage(error.code));
                });

        } else {
            toast.error("Please complete all of the fields...")
        }
    }

    async function createADoc(email, name) {
        spinner(true)
        localStorage.setItem("isAdmin", false);
        const exp = getDate90DaysOut()
        const db = getFirestore()
        const id = makeid(12)
        await setDoc(doc(db, "profiles", id), {
            type: 'Probationary',
            email: email,
            exp: exp,
            id: id,
            name: name,
            details: '',
            filex: '',
            contact: '',
            board: false,
            cell: '',
            title: '',
            member: false,
            isAdmin: false,
        }).then(() => {
            toast.success("Member Document Created...")
            onSendToParent(true)
            spinner(false)
        }).catch(err => {
            toast.error(err.message)
            spinner(false)
        })
    }

    const getProfileDoc = async () => {
        spinner(true);
        const db = getFirestore()
        const ref = collection(db, "profiles")
        try {
            const q = query(ref, where('email', "==", localStorage.getItem('email')));
            const querySnapshot = await getDocs(q);
            const accessProfile = querySnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));

            if (!checkEmpty(accessProfile[0].email)) {
                onSendToParent("profile")
            }
            spinner(false);
        } catch (error) {
            spinner(false);
            createADoc(localStorage.getItem('email'), name);
           
        }
    };

    function Login() {
        signInWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                localStorage.setItem("isAnon", userCredential.user.isAnonymous)
                localStorage.setItem("email", userCredential.user.email)
                getProfileDoc()
            }).catch((error) => {
                toast.error(getAuthErrorMessage(error.code));
            });
    }

    const sendToParentUser = (data) => {
        onSendToParent("UserX")
    }

    const callTerms = () => {
        setCompleteFields("")
        if (!checkEmpty(name) && !checkEmpty(email) && !checkEmpty(password)) {
            setShow(true)
        } else {
            setCompleteFields("You must complete all fields")
        }
    }

    return (
        <main>
            <section className='border-0'>
                <div><h4 className="xTitle animated fadeInLeft">Albuquerque Press Club</h4></div>
                <h3 className="auth-title">Sign Up</h3>
                <form>
                    <div className="error-text"><strong className="red">{completeFields}</strong></div>

                    <div className="auth-form-group">
                        <label className="meta-label" htmlFor="name">Full Name</label>
                        <input
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                            className="glass-input"
                            placeholder="Enter full name"
                            id="name"
                        />
                    </div>
                    <div className="auth-form-group">
                        <label className="meta-label" htmlFor="email-address">Email address</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            className="glass-input"
                            placeholder="name@example.com"
                            id="email"
                        />
                    </div>
                    <div className="auth-form-group">
                        <label className="meta-label" htmlFor="password">Password</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            className="glass-input"
                            placeholder="Create password"
                            id="password"
                        />
                    </div>

                    <button
                        onClick={callTerms}
                        type="button"
                        className="btn-glass-save-edit w-100"
                        style={{ width: '100%', marginTop: '10px' }}
                    >
                        Create Account
                    </button>

                    <Modal
                        show={show}
                        onHide={handleClose}
                        centered
                        contentClassName="glass-modal-content"
                        className="terms-black-theme"
                    >
                        <Modal.Header closeButton className="border-0">
                            <Modal.Title className="modified xTitle" style={{ marginBottom: 0 }}>
                                Terms
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="glass-modal-body">
                            <Terms />
                            <ToastContainer theme="dark" />
                        </Modal.Body>
                        <Modal.Footer className="border-0 d-flex justify-content-between">
                            <Button onClick={onSubmit} className="btn-glass-save-edit">
                                Agree
                            </Button>
                            <Button className="btn-glass-create" onClick={handleClose}>
                                Decline
                            </Button>

                        </Modal.Footer>
                    </Modal>




                    <div className="auth-divider">
                        <hr />
                        <span>OR</span>
                    </div>

                    <div className="auth-footer">
                        <p className="meta-label" style={{ textAlign: 'center', marginBottom: '10px' }}>
                            Already have an account?
                        </p>
                        <button
                            onClick={sendToParentUser}
                            className="btn-glass-create w-100"
                            style={{ width: '100%' }}
                        >
                            Go To Login
                        </button>
                    </div>
                </form>
            </section>
        </main>
    )
}

export default SignUp